import { useEffect, useState } from "react";
import { Gift, Check } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import WhatsAppLink from "@/components/admin/WhatsAppLink";

export default function GiftTracker() {
  const [list, setList] = useState(null);
  const load = () => api.get("/admin/gifts").then(({ data }) => setList(data.children)).catch(() => setList([]));
  useEffect(() => { load(); }, []);
  const mark = async (c, sent) => {
    await api.post(`/admin/children/${c.child_id}/gift`, { sent });
    toast.success(sent ? `Gift marked as sent for ${c.child_name}` : "Gift mark removed");
    load();
  };
  if (!list) return null;
  return (
    <div className="bg-slate-800 rounded-2xl border-2 border-pink-400/60 p-4 mb-6" data-testid="admin-gifts">
      <p className="font-bold flex items-center gap-2"><Gift size={18} className="text-pink-300" /> Year-end gift — 12 months in a row (Holiday Pack = 2, 7-day grace) + 80% of the syllabus</p>
      {list.length === 0 ? (
        <p className="text-slate-400 text-sm mt-2" data-testid="admin-gifts-empty">No child has 10+ months in a row yet.</p>
      ) : (
        <div className="mt-3 space-y-2">
          {list.map((c) => (
            <div key={c.child_id} className="flex flex-wrap items-center gap-2 text-sm bg-slate-900 rounded-xl px-3 py-2" data-testid={`admin-gift-${c.child_id}`}>
              <span className={`px-2 py-0.5 rounded-full text-xs font-bold ${c.gift_sent ? "bg-green-600" : c.reached ? "bg-pink-500" : "bg-amber-300 text-slate-900"}`}>
                {c.gift_sent ? "Gift sent" : c.eligible ? "Gift earned" : `${c.months}/12 months · ${c.syllabus}%`}
              </span>
              <span className="font-semibold">{c.child_name} · G{c.grade}</span>
              <span className="text-slate-400" data-testid={`admin-gift-status-${c.child_id}`}>{c.months} months in a row (best {c.best_months}) · {c.syllabus}% of the syllabus done</span>
              <a href={`mailto:${c.parent_email}`} className="text-blue-300 underline">{c.parent_name} · {c.parent_email}</a>
              <WhatsAppLink number={c.parent_whatsapp} consentAccount={c.parent_consent_account} consentMarketing={c.parent_consent_marketing} name={c.parent_name} testId={`gift-whatsapp-${c.child_id}`} />
              {c.gift_sent ? (
                <button onClick={() => mark(c, false)} className="ml-auto text-xs underline text-slate-400" data-testid={`admin-gift-undo-${c.child_id}`}>Undo</button>
              ) : (
                <button onClick={() => mark(c, true)} className="ml-auto inline-flex items-center gap-1 rounded-full bg-pink-600 px-3 py-1 text-xs font-semibold" data-testid={`admin-gift-mark-${c.child_id}`}><Check size={12} /> Mark gift sent</button>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
